import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { Paginator } from "primereact/paginator";
import MembreCard from "../MembreCard/MembreCard";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./AttribuerDroits.scss";
import { updateAdmin } from "Redux/Actions/adminActions";

const AttribuerDroits = (props) => {
  const [surname, setSurname] = useState("");
  const [firstname, setFirstname] = useState("");
  const [users, setUsers] = useState([]);
  const containerAttribuerRef = useRef(null);
  const [isSearched, setIsSearched] = useState(false);

  const handleRecherche = () => {
    setIsSearched(true);
    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/users`);
    //Si les champs ne sont pas vides on ajoute les paramètres de recherche à l'url
    if (surname != "") {
      url.searchParams.set("surname", surname);
    }
    if (firstname != "") {
      url.searchParams.set("firstname", firstname);
    }
    getUsersFiltered(url);
  };
  /**
   * Permet de filtrer les membres par nom et prénom
   */
  const getUsersFiltered = (url) => {
    axios
      .get(url.toString(), {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };
  const onBasicPageChange = (event) => {
    props.handleUpdatePagination({ currentPage: event.page + 1 });
    props.handleUpdatePagination({ paginationBasicFirst: event.first });
    props.handleUpdatePagination({ paginationBasicRows: event.rows });
    if (props.admin.currentPage !== 1) {
      window.scroll({
        top: containerAttribuerRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    if (props.admin.paginationBasicFirst > 0) {
      window.scroll({
        top: containerAttribuerRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  }, [props.admin.paginationBasicFirst]);

  const filterUserByRoles = (userArray) => {
    const usersFiltered = userArray.filter((user) =>
      user.userRoles.find(
        (role) =>
          role.roleName === "ROLE_ALUMNI" ||
          role.roleName === "ROLE_ETUDIANT" ||
          role.roleName === "ROLE_PERSONNEL_UNIVERSITE"
      )
    );
    return usersFiltered;
  };

  // eslint-disable-next-line no-unused-vars
  const getRoles = (user) => {
    const roles = [];
    for (let i = 0; i < user.length; i++) {
      roles.push({ roleName: user[i].role_name, endAt: user[i].end_at });
    }
    return roles;
  };
  return (
    <div className="attribuerDroits" ref={containerAttribuerRef}>
      <h3 className="attribuerDroits__title">
        Rechercher une personne pour lui affecter ou modifier des droits
      </h3>
      <div className="attribuerDroits__form">
        <div className="attribuerDroits__form__champ">
          <label>Prénom</label>
          <InputText
            value={firstname}
            placeholder="Marie, Paul..."
            onChange={(e) => setFirstname(e.target.value)}
          />
        </div>
        <div className="attribuerDroits__form__champ">
          <label>Nom</label>
          <InputText
            value={surname}
            placeholder="Dupont, Gary..."
            onChange={(e) => setSurname(e.target.value)}
          />
        </div>
      </div>
      <BtnBleu btnTexte="Rechercher" btnAction={() => handleRecherche()} />
      {isSearched &&
        (filterUserByRoles(users).length > 0 ? (
          <>
            {filterUserByRoles(users)
              .slice(
                props.admin.paginationBasicFirst,
                props.admin.paginationBasicRows * props.admin.currentPage
              )
              .map((user) => (
                <MembreCard
                  currentRole={user.userRoles[0].roleName}
                  key={user.id}
                  userId={user.id}
                  dejaRole={true}
                  nom={user.surname}
                  prenom={user.firstname}
                  roles={user.userRoles}
                  handleRecherche={handleRecherche}
                  rolesFromDb={props.rolesFromDb}
                />
              ))}
            <Paginator
              first={props.admin.paginationBasicFirst}
              pageLinkSize={screen.width <= 830 ? 1 : 3}
              rows={props.admin.paginationBasicRows}
              totalRecords={filterUserByRoles(users).length}
              leftContent={"Page précédente"}
              rightContent={"Page suivante"}
              onPageChange={onBasicPageChange}
            />
          </>
        ) : (
          <span className="attribuerDroits__empty">
            <div>
              Aucun étudiant, alumni ou membre du personnel ne correspond à
              votre recherche.
            </div>
          </span>
        ))}
    </div>
  );
};

AttribuerDroits.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  checked: PropTypes.bool,
  setChecked: PropTypes.func,
  admin: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  rolesFromDb: PropTypes.array,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  admin: state.admin,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => dispatch(updateAdmin(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AttribuerDroits);
